import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children"];
import React, { forwardRef } from 'react';
import { N500 } from '@atlaskit/theme/colors';
import { headingSizes } from '@atlaskit/theme/typography';
import { overrideStyleFunction } from '../../common/styles';
import { CustomItem } from '../Item';

var Container = function Container(props) {
  return /*#__PURE__*/React.createElement("div", props);
};

var Header = /*#__PURE__*/forwardRef(function (props, ref) {
  var cssFn = overrideStyleFunction(function () {
    var _ref;

    return _ref = {
      userSelect: 'auto'
    }, _defineProperty(_ref, '[data-item-title]', {
      fontSize: headingSizes.h400.size,
      letterSpacing: '-0.003em',
      fontWeight: 600,
      color: "var(--ds-text-highEmphasis, ".concat(N500, ")")
    }), _defineProperty(_ref, 'div&:hover', {
      backgroundColor: 'transparent',
      cursor: 'default'
    }), _defineProperty(_ref, 'div&:active', {
      backgroundColor: 'transparent',
      color: "var(--ds-text-highEmphasis, ".concat(N500, ")")
    }), _ref;
  }, props.cssFn);
  return /*#__PURE__*/React.createElement(CustomItem, _extends({}, props, {
    ref: ref,
    component: props.component || Container,
    cssFn: cssFn,
    overrides: {
      Title: {
        render: function render(_, _ref2) {
          var children = _ref2.children,
              props = _objectWithoutProperties(_ref2, _excluded);

          return /*#__PURE__*/React.createElement("h2", props, children);
        }
      }
    }
  }));
});
export default Header;